// extracted by mini-css-extract-plugin
module.exports = {"loading-label":"LoadingLabel_loading-label__Mwpie","loadingBackgroundAnimation":"LoadingLabel_loadingBackgroundAnimation__bAvDv"};